import * as React from "react";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutGridColumnRow,
  UitkLayoutGridSpan,
} from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export const CitiTripleDipIconSectionWithAdd = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  if (items.length !== 3) {
    return null;
  }

  const IconColSpan = {
    small: 1 as UitkLayoutGridSpan,
    medium: 1 as UitkLayoutGridSpan,
    large: 5 as UitkLayoutGridSpan,
    extra_large: 5 as UitkLayoutGridSpan,
  };

  const gridColumns = {
    extra_large: 6 as UitkLayoutGridColumnRow,
    large: 6 as UitkLayoutGridColumnRow,
    medium: 1 as UitkLayoutGridColumnRow,
    small: 1 as UitkLayoutGridColumnRow,
  };

  return (
    <UitkLayoutGrid columns={gridColumns} space="six">
      <UitkLayoutGridItem colSpan={IconColSpan}>
        <div>
          <div className="uitk-type-center all-b-padding-three">
            <div dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
          </div>
          <UitkText align="center" size={500} weight="bold">
            <div dangerouslySetInnerHTML={decorateEditorialHtml(items[1].text)} />
          </UitkText>
          <UitkText align="center" size={300}>
            <div dangerouslySetInnerHTML={decorateEditorialHtml(items[2].text)} />
          </UitkText>
        </div>
      </UitkLayoutGridItem>

      <UitkLayoutGridItem colSpan={1}>
        <div>
          <UitkText align="center">
            <UitkIcon name="add" size={UitkIconSize.LARGE} className="all-b-padding-one" />
          </UitkText>
        </div>
      </UitkLayoutGridItem>
    </UitkLayoutGrid>
  );
};
export default CitiTripleDipIconSectionWithAdd;
